<div  class = "training-required-button" [ngClass] = "{'training-text': showTrainingStyle, 'previous-shifts': previousShiftView }" [class.staffy-requests]="cssClass === 'staffy-requests'">
  
    <div class="creator-name">
        
        <!-- For Open Request non recurring, where job is received as a single array -->
        <div class = "type-and-date" *ngIf="(!jobItem.recurrentShiftTemplateId && !jobItem?.recurringShift?.isTrue)">
            <!-- <div > -->
                <!-- <div class = "training-icon" *ngIf = "showTrainingStyle">
                    <img src="assets/images/book.png">
                </div> -->

                <span class="rq-icon" *ngIf="cssClass"><i class="fas" [ngClass]="jobItem?.isVisitBasedShift ? 'fa-handshake' : 'fa-clipboard-list'"></i></span>

                <div class = "flex mobile-flex rq-title">
                    <!-- <div *ngIf = "showTrainingStyle" class = "training-content"><span>Training Shift</span></div> -->
                    <div *ngIf="!previousShiftView">
                        <h1 *ngIf = "jobItem?.isABroadcastRequest?.isTrue">
                            {{ jobItem?.isVisitBasedShift ? ('UNFILLED_REQUESTS.Visit Request'| translate) : ('UNFILLED_REQUESTS.Shift Request'| translate)}} </h1>
                       
                        <h1 *ngIf="!jobItem?.isABroadcastRequest?.isTrue ">
                            {{'UNFILLED_REQUESTS.Direct hire'| translate}}
                        </h1>
                    </div>

                    <div *ngIf="previousShiftView">
                        <h1 >
                            {{jobStatus}}
                        </h1>
                    </div>
                    <p *ngIf="jobItem"
                    class = "large-font text-capitalize bottom-5 no-margin">
                    {{ ('SKILLS.' + jobItem.skill) | translate }}
                </p>
                    <span class="also-accepts-chip" *ngIf="getAlsoAcceptsSkill(jobItem) as alsoAcceptsSkill">
                        Also accepts {{ skillShortLabel(alsoAcceptsSkill) }}
                    </span>
                </div>

                <div class="vertical-divider" *ngIf="previousShiftView">

                </div>
               
            <!-- </div> -->
            

          <div class = "flex mobile-flex rq-count">
            <div class="shift-info-container">
            <h1 *ngIf = "jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                {{jobItem.jobs.length}} Shift <span *ngIf="showTrainingStyle">(Training)</span>
                <span *ngIf="jobItem.isABroadcastRequest?.vacancies > 1">
                   
                                     
                                          - {{jobItem.isABroadcastRequest.vacancies}}
                                          Vacancies 
                                 
                </span>
            </h1>
            </div>
           
              <p *ngIf = "jobItem?.shiftStartTime" class="open-shift-text text-capitalize no-margin">
                {{jobItem.shiftStartTime | momentPipeUnix:'ddd'}}  {{jobItem.shiftStartTime | momentPipeUnix:'MMM DD'}}<span *ngIf="previousShiftView">, {{ jobItem.shiftStartTime | momentPipeUnix:'YYYY' }}
                  </span>
              </p>
          </div>

          <div class="vertical-divider" *ngIf="previousShiftView">

          </div>

          <div *ngIf = "state !== 'ongoing-shifts' && !previousShiftView" class = "flex flex-row rq-actions">
            <i (click)="handleDeleteShift()" class="fas fa-trash"><span class="lbl" *ngIf="cssClass">Delete</span></i>
            <i (click)="handleEditShift($event)"  class="fas fa-pencil-alt" ><span class="lbl" *ngIf="cssClass">Edit</span></i>
        
        </div>

        <div class="flex " *ngIf="previousShiftView">
            <div class="shift-info-container">
        
                <h1 *ngIf="jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                    Clock-in
                </h1>
            </div>
        
        
            <p class="open-shift-text text-capitalize no-margin text-align-center">
                {{jobItem?.isVisitBasedShift ? '-' : (jobItem.shiftStartTime | momentPipeUnix:'hh:mm a')}} </p>
        </div>

        <div class="flex" *ngIf="previousShiftView">
            <div class="shift-info-container">
        
                <h1 *ngIf="jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                    Clock-out
                </h1>
            </div>
        
        
            <p class="open-shift-text text-capitalize no-margin text-align-center">
                {{jobItem?.isVisitBasedShift ? '-' : (jobItem.shiftEndTime | momentPipeUnix:'hh:mm a')}}
            </p>
        </div>

        <div class="vertical-divider" *ngIf="previousShiftView">

        </div>

        <div class="flex flex-row hours-text" *ngIf="previousShiftView">
            <div class="shift-info-container">
        
                <h1 *ngIf="!jobItem?.isVisitBasedShift && jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                    {{shiftDuration}} {{shiftDuration > 1 ? 'hours' : 'hour'}}
                </h1>
                <h1 *ngIf="jobItem?.isVisitBasedShift && jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                    Visit
                </h1>
                
            </div>
        
        
        </div>
        </div>


      <!-- For open request recurring/recurrent shifts, where jobs are received as more than 1 array -->
        <div class = "type-and-date" *ngIf = "jobItem?.jobs.length >= 1 && jobItem?.recurringShift?.isTrue">
            
                <!-- <div class = "training-icon" *ngIf = "showTrainingStyle">
                    <img src="assets/images/book.png">
                </div> -->

                <span class="rq-icon" *ngIf="cssClass"><i class="fas" [ngClass]="jobItem?.isVisitBasedShift ? 'fa-handshake' : 'fa-clipboard-list'"></i></span>

                <div class = "flex mobile-flex rq-title">
                    <!-- <div *ngIf = "showTrainingStyle" class = "training-content"><span>Training Shift</span></div> -->
                    <div *ngIf="!previousShiftView">
                        <h1 *ngIf="jobItem?.isABroadcastRequest.isTrue">
                            {{ jobItem?.isVisitBasedShift ? ('UNFILLED_REQUESTS.Visit Request'| translate) : ('UNFILLED_REQUESTS.Shift Request'| translate)}} </h1>
                        <h1 *ngIf="!jobItem?.isABroadcastRequest.isTrue">
                            {{'UNFILLED_REQUESTS.Direct hire'| translate}}
                        </h1>
                    </div>

                    <div *ngIf="previousShiftView">
                        <h1 >
                            {{jobStatus}}
                        </h1>
                    </div>
                    
                        
                        
                    
                    <p *ngIf="jobItem"
                    class = " large-font text-capitalize bottom-5 no-margin">
                    {{ ('SKILLS.' + jobItem.skill) | translate }}
                </p>
                    <span class="also-accepts-chip" *ngIf="getAlsoAcceptsSkill(jobItem) as alsoAcceptsSkill">
                        Also accepts {{ skillShortLabel(alsoAcceptsSkill) }}
                    </span>


                <!-- <div class = "flex-column recurrent" *ngIf = "jobItem.recurrentShiftTemplateId">
                    <div class = "first-col">
                        <i class="fas fa-repeat"></i>
                        <div class = "training-content light"><span>Recurring shift</span></div>
                    </div>

                    <div class = "second-col">
                        <div class = "days">
                            {{ shiftInterval }} on {{ shiftIntervalDays }}
                        </div>
                        <div class = "date-range">{{ jobItem?.recurrentShiftTemplateId.startDate | momentPipeUnix:'MMM DD' }} - {{ jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'MMM DD' }}
                        </div>
                    </div>

                    <div class = "third-col">
                        <div class = "tooltip">
                            <i class="fa fa-info-circle " aria-hidden="true"></i>
                            <span class="tooltiptext"><span class = "bold">This is a recurring shift</span> that will be available for {{ shiftInformation }}</span>
                        </div>
                    </div>
                </div> -->
            </div>


            <div class="vertical-divider" *ngIf="previousShiftView">

            </div>
              
            <div class="flex mobile-flex rq-count">
            
                <div class="shift-info-container">

            <h1 *ngIf = "jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                {{jobItem.jobs.length}} Shifts <span *ngIf="showTrainingStyle">(Training) </span>
                <span *ngIf="jobItem.isABroadcastRequest?.vacancies > 1">
               
                                 
                    - {{jobItem.isABroadcastRequest.vacancies}}
                    Vacancies 
           
</span>
</h1>
        </div>
                

                <p class="open-shift-text text-capitalize no-margin">
                    {{jobItem.shiftStartTime | momentPipeUnix:'ddd'}} {{jobItem.shiftStartTime | momentPipeUnix:'MMM DD'}}<span *ngIf="previousShiftView">, {{ jobItem.shiftStartTime | momentPipeUnix:'YYYY' }}
                      </span> - {{jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'ddd'}} {{jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'MMM DD'}}<span *ngIf="previousShiftView">, {{ jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'YYYY' }}
                      </span>
                </p>
            </div>

            <div *ngIf = "state !== 'ongoing-shifts' && !previousShiftView" class="flex flex-row rq-actions">
                <i (click)="handleDeleteShift()" class="fas fa-trash"><span class="lbl" *ngIf="cssClass">Delete</span></i> 
                <i *ngIf="!jobItem.recurrentShiftTemplateId || (jobItem.recurrentShiftTemplateId&&!jobItem.isVisitBasedShift)" (click)="handleEditShift($event)" class="fas fa-pencil-alt" ><span class="lbl" *ngIf="cssClass">Edit</span></i>
               
            </div>

            <div class="vertical-divider" *ngIf="previousShiftView">

            </div>

            <div class="flex" *ngIf="previousShiftView">
                <div class="shift-info-container">
            
                    <h1 *ngIf="jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                        Clock-in
                    </h1>
                </div>
            
            
                <p class="open-shift-text text-capitalize no-margin text-align-center">
                    {{jobItem?.isVisitBasedShift ? '-' : (jobItem.shiftStartTime | momentPipeUnix:'hh:mm a')}} </p>
            </div>

            <div class="flex" *ngIf="previousShiftView">
                <div class="shift-info-container">
            
                    <h1 *ngIf="jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                        Clock-out
                    </h1>
                </div>
            
            
                <p class="open-shift-text text-capitalize no-margin text-align-center">
                    {{jobItem?.isVisitBasedShift ? '-' : (jobItem.shiftEndTime | momentPipeUnix:'hh:mm a')}}
                </p>
            </div>

            <div class="vertical-divider" *ngIf="previousShiftView">

            </div>

            <div class="flex flex-row hours-text" *ngIf="previousShiftView">
                <div class="shift-info-container">
            
                    <h1 *ngIf="!jobItem?.isVisitBasedShift && jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                        {{shiftDuration}} {{shiftDuration > 1 ? 'hours' : 'hour'}}
                    </h1>
                    <h1 *ngIf="jobItem?.isVisitBasedShift && jobItem?.shiftStartTime" class="open-shift-text text-capitalize mont-bold no-margin shift-info">
                        Visit
                    </h1>
                </div>
            
            
            </div>
              
  
        </div>
        <!-- add two icon for delete and edit through <i> tag using font-awesome -->
       
    </div>
  
  </div>
